const win = $(window);
const defaults = {
    offset: 20,
    animate: false,
    container: 'html, body',
    duration: 1000
};
let targetSelector;

export function setScrollTarget(selector) {
    targetSelector = selector;
}

export function getScrollTarget() {
    const s = targetSelector;
    targetSelector = null;
    return s;
}

function getTargetTop(selector, target, options) {
    if (selector === 'top') {
        return 0;
    }
    if (options.offset != null) {
        return target.offset().top - options.offset;
    }
    return target.offset().top;
}

export function scrollTo(selector, options) {
    const map = (v, k) => (options && options[k] != null) ? options[k] : v;
    options = _.mapValues(defaults, map);
    const target = $(selector);

    if (selector !== 'top' && target.length === 0) {
        return Promise.resolve();
    }

    const top = getTargetTop(selector, target, options);
    const container = $(options.container);

    return new Promise(function(resolve) {
        if (!options.animate) {
            setTimeout(function() {
                container.scrollTop(top);
                resolve();
            }, 50);
            return;
        }

        if (options.duration === defaults.duration) {
            const diff = Math.round(top - container.scrollTop());
            options.duration = Math.abs(Math.round(diff * 0.3));
        }
        if (options.duration > 1000) {
            options.duration = 1000; // cap at 1 second
        }
        container
            .stop()
            .animate({ scrollTop: top }, {
                easing: 'swing',
                duration: options.duration,
                complete() {
                    const targetTop = getTargetTop(selector, target, options);
                    // Check final position
                    // Scrolling may cause images with unspecified dimensions to load, pushing target down
                    if (top !== targetTop) {
                        container.stop().animate({ scrollTop: targetTop }, {
                            duration: 100,
                            complete: resolve
                        });
                    } else {
                        resolve();
                    }
                }
            });
    });
}

export function getScrollOffsets(window) {
    // Use the specified window or the current window if no argument
    const w = window || win;

    // This works for all browsers except IE versions 8 and before
    if (w.pageXOffset != null) {
        return {
            x: w.pageXOffset,
            y: w.pageYOffset
        };
    }

    // For IE (or any browser) in Standards mode
    const d = w.document;
    if (document.compatMode === 'CSS1Compat') {
        return {
            x: d.documentElement.scrollLeft,
            y: d.documentElement.scrollTop
        };
    }

    // For browsers in Quirks mode
    return {
        x: d.body.scrollLeft,
        y: d.body.scrollTop
    };
}
